import {
  dispatchForImportFromSpreadsheet,
  dispatchForValidateSpreadsheet,
} from 'bulk-import/SpreadsheetBulkImportActions';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import * as StageEntryActions from 'workflows/stage-entries/StageEntryActions';
import {dispatchStageRunSamplesFetched} from 'workflows/StageRunActions';

import * as InputTableImportDAO from './InputTableImportDAO';

export function validateNewSamplesForInputTableImport(stageEntryId: string): void {
  dispatchForValidateSpreadsheet((spreadsheetParams: InputTableImportDAO.SpreadsheetParams) =>
    InputTableImportDAO.validateNewSamplesForInputTableImport(spreadsheetParams, stageEntryId)
  );
}

export function addNewSamplesForInputTableImport(stageEntryId: string): void {
  LoadingScreen.show('Importing...');

  dispatchForImportFromSpreadsheet((spreadsheetParams: InputTableImportDAO.SpreadsheetParams) =>
    InputTableImportDAO.addNewSamplesForInputTableImport(spreadsheetParams, stageEntryId)
      .done(
        ({
          stageEntryDetails,
          entryVersion,
          stageRunSamples,
        }: InputTableImportDAO.AddNewSamplesForInputTableImportResponse) => {
          dispatchStageRunSamplesFetched({stageRunSamples});
          StageEntryActions.dispatchStageEntryDetailsChange(stageEntryDetails);
          StageEntryActions.dispatchStageEntryVersionChange(entryVersion, stageEntryDetails.stageEntry);
        }
      )
      .always(() => {
        LoadingScreen.hide();
      })
  );
}
